/* eslint-disable react/prop-types */
import { Container, GradientLoadingIndicator } from 'edrolo-style-guide';
import { STATUS } from '../../constants';
import { useEffect } from 'react';
import { QuestionInstructions } from '../QuestionInstructions';
import QuestionSolution from '../QuestionSolution';
import { AnsweredQuestion } from '../AnsweredQuestion';
import WistiaUtils from 'edrolo/utils/WistiaUtils';

const QuestionView = ({
  examId,
  examStatus,
  loadExam,
  loadExamSolution,
  question,
  solution,
}) => {
  // WARNING: `solution` has `solution` - and a bunch of other stuff - nested inside.

  useEffect(() => {
    if (examStatus === STATUS.UNINITIALIZED) {
      loadExam(examId);
    }
    if (!solution) {
      loadExamSolution(examId);
    }
  }, [examId, solution, examStatus, loadExam, loadExamSolution]);

  if (examStatus !== STATUS.READY || !solution || !question) {
    return <GradientLoadingIndicator />;
  }

  return (
    <Container>
      <QuestionInstructions question={question} />
      <AnsweredQuestion question={question} solvedExamQuestion={solution} />
      <QuestionSolution
        headingText="Solution"
        questionId={question.get('id')}
        videoHash={solution.getIn(['solution', 'video', 'wistia_hashed_id'])}
        videoThumbnailUrl={WistiaUtils.getThumbnail(
          solution.getIn(['solution', 'video'])
        )}
        explanation={solution.getIn(['solution', 'explanation'])}
      />
    </Container>
  );
};

export default QuestionView;
